var auEditorInitiator = Object.assign(auEditorInitiator || {}, {
    ecDriver: {},
    editorLoaded: false,
    isApplyOptions: false,
    getEditorDiv: function() {
        return document.querySelector("[target='editor-parent-for-product']") || document.querySelector("#editor-parent-for-product")
    },
    userId: function() {
        return this.getUserIdForCc();
    },
    ccPages: function() {
        return {
            "product": document.querySelector("[target='main-product-page']"),
            "editor": document.querySelector("[target='cc-editor-page']") || document.querySelector("#cc-editor-page")
        }
    },
    getCurrentSessionId: function() {
        var sessionId = "guest";
        var coockie = document.cookie;
        var coockieArr = coockie.split(";")
        var coockieObj = {};
        coockieArr.forEach(function(equal) {
            var arr = equal.split("=");
            var key = arr[0];
            var value = arr[1];
            coockieObj[key.trim()] = value;
        });

        function guid() {
            function s4() {
                return Math.floor((1 + Math.random()) * 0x10000)
                    .toString(16)
                    .substring(1);
            }
            return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
        };
        sessionId =
            coockieObj["_shopify_y"] ||
            coockieObj["_y"] ||
            coockieObj["_shopify_s"] ||
            coockieObj["_s"] ||
            coockieObj["__ssid"] || guid();

        sessionId = "shopify_" + sessionId;
        return sessionId;
    },
    getRootUrl: function(url) {
        return url.toString().replace(/^(.*\/\/[^\/?#]*).*$/, "$1");
    },
    getQueryParameters: function(str) {
        var result = (str || document.location.search).replace(/(^\?)/, '').split("&").map(function(n) {
            return n = n.split("="), this[n[0]] = n[1], this
        }.bind({}))[0];
        delete result[""];
        Object.keys(result).forEach(function(key) {
            result[key] = decodeURIComponent(result[key]);
        });
        if (Object.keys(result).length == 0 && result.constructor === Object) {
            result = null;
        }
        return result;
    },
    _getFormElement: function() {
        var forms = Array.from(document.querySelectorAll("form[action='/cart/add']"));
        if (forms.length === 1)
            return forms[0];
        var ignoredClasses = ["product-form-nojs"];
        forms = forms.filter(function(form) {
            var isFiltered = false;
            ignoredClasses.forEach(function(cls) {
                isFiltered = isFiltered || form.classList.contains(cls);
            });
            return !isFiltered;
        });
        return forms[0];
    },
    _getQuantityInputElement: function() {
        var formElement = this._getFormElement();
        return formElement.querySelector("[name='quantity']");
    },
    getQuantityFromForm: function() {
        var self = this;
        var formElement = self._getFormElement();
        var _getByQuerySelector = function() {
            var inputElem = self._getQuantityInputElement();
            if (inputElem) {
                return Number(inputElem.value);
            }
            return null;
        };
        var _getByFormData = function() {
            var formString = new URLSearchParams(new FormData(formElement).toString()).toString();
            var objData = self.getQueryParameters(formString);
            if (objData && objData.quantity) {
                return Number(objData.quantity);
            }
            return null;
        };
        return _getByQuerySelector() || _getByFormData() || 1;
    },
    ccGoToPage: function(page, idArr) {
        var elem = this.ccPages()[page];
        elem.style.display = "inline-block";
        elem.style.visibility = "visible";
        elem.style.position = "static";
        elem.style.top = "0px";
        elem.style.left = "0px";
        Object.keys(this.ccPages()).forEach(function(item) {
            if (item != page) {
                this.ccPages()[item].style.visibility = "hidden";
                this.ccPages()[item].style.position = "absolute";
                this.ccPages()[item].style.top = "-9999px";
                this.ccPages()[item].style.left = "-9999px";
            }
        }.bind(this));
        var relatedProducts = document.querySelector(".related-products-wrapper");
        if (page === "product") {
            if (relatedProducts) {
                relatedProducts.style.display = "inline-block";
            }
        } else if (page === "editor") {
            if (relatedProducts) {
                relatedProducts.style.display = "none";
            }
        }
    },
    getSelectedVariantId: function() {
        // get from form or from shopifyMetaAnalitics selectedVariantId
        var self = this;
        var queryParams = self.getQueryParameters();
        var formElement = self._getFormElement();
        var _getFromFormByQuerySelector = function() {
            var inputElem = formElement.querySelector("[name='id']");
            if (inputElem) {
                return Number(inputElem.value);
            }
            return null;
        };
        var _getFromForm = function() {
            var formString = new URLSearchParams(new FormData(formElement)).toString();
            if (formString) {
                var objData = self.getQueryParameters(formString);
                if (objData && objData.id) {
                    return objData.id;
                } else {
                    return null;
                }
            } else {
                return null;
            }
        };
        var _getFromShopifyMeta = function() {
            try {
                return ShopifyAnalytics.meta.selectedVariantId;
            } catch (ex) {
                return null;
            }
        };
        var _getFromQueryString = function() {
            if (queryParams && queryParams['variant']) {
                return queryParams['variant'];
            } else {
                return null;
            }
        };
        var selectedVariantId = _getFromFormByQuerySelector() || _getFromForm() || _getFromShopifyMeta() || _getFromQueryString();
        return selectedVariantId == null ? selectedVariantId : Number(selectedVariantId);
    },
    getExistingOrder: function() {
        var queryParams = this.getQueryParameters();
        // order already exist
        if (queryParams && queryParams['state']) {
            return {
                state: queryParams['state'],
                key: queryParams['key']
            };
        }
        return null;
    },
    getLanguage: function() {
        if (this.locale && this.locale.length > 0)
            return this.locale;
        var language = "EN";
        try {
            var lang = document.querySelector("html").lang;
            lang = lang.substr(0, 2);
            if (lang && lang.length > 0)
                language = lang;
        } catch (ex) {
            console.warn("Can't parse locale");
        }
        return language;
    },
    getConcurrency: function() {
        if (this.currency && this.currency.length > 0)
            return this.currency;
        try {
            return window.Shopify.currency.active || window.ShopifyAnalytics.meta.currency
        } catch (ex) {
            console.warn("Can't parse currency");
            return "USD";
        };
    },
    getBoldVariantsDiscount: function() {
        var variants = {};
        try {
            variants = BOLD.common.Shopify.variants;
        } catch (e) {}
        return variants;
    },
    loadEditor: function() {
        var self = this;
        var queryParams = self.getQueryParameters() || {};

        if (!queryParams.quantity) {
            queryParams.quantity = self.getQuantityFromForm();
        }

        var ccUrl = self.shopMeta.editorUrl;
        var ccRootUrl = self.getRootUrl(ccUrl) + "/";
        self.prodMeta.editorPath = self.prodMeta.editorPath.substring(self.prodMeta.editorPath.toLowerCase().indexOf("editors") - 1);
        var editorLink = ccUrl + self.prodMeta.editorPath + "/";
        var path = ccRootUrl + "editor/getFilejsonp?subPath=" + ccUrl.substring(ccUrl.toLowerCase().indexOf("users") - 1) + self.prodMeta.editorPath;
        var editorJsonUrl = path + "&filePath=editor.json";
        var configJsonUrl = path + "&filePath=configs/" + self.prodMeta.configName + ".json";

        configJsonUrl = configJsonUrl.replace(/\\/g, "/");
        editorJsonUrl = editorJsonUrl.replace(/\\/g, "/");

        self.moduleLoader.loadJsonJsonp(editorJsonUrl).then(function(editorJson) {
            var editorModuleName = !!editorJson.entry ? editorJson.entry : "editor.js";
            var editorJsUrl = editorLink + editorModuleName;
            editorJsUrl = editorJsUrl.replace(/\\/g, "/").replace("//Editors/", "/Editors/");

            self.moduleLoader.dynamicImport("ecommerceDriver", self.driverUrl).then(function(driverImportData) {
                var ecommerceDriver = driverImportData.ecommerceDriver;
                self.moduleLoader.dynamicImportDefault("editor", editorJsUrl).then(function(editorImportData) {
                    var editor = editorImportData.editor.editor || editorImportData.editor;
                    var productModel = self.product;
                    productModel.metafields = self.prodMeta;
                    self.moduleLoader.loadJsonJsonp(configJsonUrl).then(function(config) {
                        try {
                            config = config.config || config;
                            // modify config for base-editor compatability
                            if (queryParams) {
                                if (queryParams.state !== undefined) {
                                    if (config.productDefinition)
                                        config.productDefinition = queryParams.state;
                                    if (config.editorConfig)
                                        config.editorConfig.autoLoadUserInfo = false;
                                }
                                if (queryParams.overwrite !== undefined) {
                                    if (config.steps.editor) {
                                        config.steps.editor.overwrite = queryParams.overwrite;
                                    }
                                }
                            }

                            var lang = self.getLanguage();
                            self.shopMeta.language = lang;
                            config.language = lang;

                            self.shopMeta.currency = self.getConcurrency();

                            productModel.selectedVariantId = self.getSelectedVariantId();

                            var boldVariantsDiscount = self.getBoldVariantsDiscount();
                            Object.keys(boldVariantsDiscount).forEach(function(variantId) {
                                var currentVariant = productModel.variants.find(function(variant) {
                                    return variant.id.toString() === variantId.toString();
                                });
                                if (currentVariant) {
                                    currentVariant.discount = boldVariantsDiscount[variantId].csp_metafield || {};
                                }
                            });

                            var quantity = Number(queryParams && queryParams.quantity ? queryParams.quantity : 1);
                            var existingOrder = self.getExistingOrder();

                          ecommerceDriver.init(productModel, editor, config, self.shopMeta, existingOrder, quantity, {
                                id: self.userId()
                              }).then(function(driver) {
                                  self.ecDriver = driver;
                                  var editorParentDiv = self.getEditorDiv();
                                  editorParentDiv.innerHTML = "";
                                  driver.products.current.renderEditor(editorParentDiv);
                                  editorParentDiv.addEventListener("load", function(e) {
                                      self.editorLoaded = true;
                                      if (self.isApplyOptions === false) {
                                          self.applyOptions();
                                          self._setOrderQuantity();
                                      }
                                  });

  //                                 var priceDiv = document.querySelector(".theme-money").parentElement;
  //                                 var subFunction = function(cart) {
  //                                     priceDiv.innerHTML = "";
  //                                     var itemsData = cart.lineItems.map(function(lineItem, index) {
  //                                         return {
  //                                             name: lineItem.product.title,
  //                                             price: lineItem.priceLocalized
  //                                         };
  //                                     });
  //                                     var htmlString = "";
  //                                     itemsData.forEach(function(itemData) {
  //                                         htmlString += ("<div>" + itemData.name + " - " + itemData.price + "</div>");
  //                                     });
  //                                     htmlString += ("<div>Total - " + cart.priceLocalized + "</div>");
  //                                     priceDiv.innerHTML = htmlString;
  //                                 };
  //                                 driver.cart.onPriceChanged.subscribe(subFunction);
  //                                 var priceObserver = new MutationObserver(function(mutations) {
  //                                     var addedNodesMutation = mutations.find(function(x) {
  //                                         return x.type === "childList" && x.addedNodes.length > 0;
  //                                     });
  //                                     if (addedNodesMutation.addedNodes[0].tagName.toLowerCase() === "span") {
  //                                         subFunction(self.ecDriver.cart);
  //                                     }
  //                                 }.bind(self));
  //                                 priceObserver.observe(priceDiv, {
  //                                     subtree: true,
  //                                     childList: true,
  //                                     attributes: true,
  //                                     attributeOldValue: true,
  //                                 });
                          });
                            
                        } catch (err) {
                            console.error(err);
                        }
                    }, function(err) {
                        console.error(err);
                        console.error("Failed to load config.json from " + configJsonUrl);
                    });
                }, function(err) {
                    console.error(err);
                    console.error("Failed to load editor.js from " + editorJsUrl);
                });
            }, function(err) {
                console.error(err);
                console.error("Failed to load ecommerce-driver.js from " + self.driverUrl);
            });
        });
    },
    applyOptions: function() {
        var selectedVariantId = this.getSelectedVariantId();
        var loadedVariantId = this.ecDriver.products.current.variations.current.id;
        if (loadedVariantId != selectedVariantId) {
            setTimeout(function() {
                this.ecDriver.products.current.updateVariant(selectedVariantId);
            }.bind(this), 1000);
        }
    },
    init: function() {
        var self = this;
        var designButton = document.querySelector("[target='cc-editor-button']");
        if (designButton) {
            var observerCount = 0;
            var observer = new MutationObserver(function(mutations) {
                observerCount++;
                if (observerCount > 250) {
                    observer.disconnect();
                }
                var attributeMutation = mutations.find(function(x) {
                    return x.type === "attributes" && x.target === designButton && x.attributeName === "disabled";
                });
                var addedNodesMutation = mutations.find(function(x) {
                    return x.type === "childList" && x.addedNodes.length > 0;
                });
                try {
                    if (!attributeMutation || !attributeMutation.target.disabled) {
                        if (addedNodesMutation.target.innerText.toLowerCase() !== this.designButtonText.toLowerCase())
                            addedNodesMutation.target.innerText = this.designButtonText;
                    }
                } catch (e) {}
            }.bind(self));
            observer.observe(designButton, {
                subtree: true,
                childList: true,
                attributes: true,
                attributeOldValue: true,
            });

            designButton.addEventListener("click", function(e) {
                e.preventDefault();
                if (self.editorLoaded === true) {
                    self.isApplyOptions = true;
                    self.applyOptions();

                    self._setOrderQuantity();
                }
                // uncomment next line to disable preload
                // self.loadEditor();    
                self.ccGoToPage("editor");

                self.getEditorDiv().scrollIntoView();
            });

            var queryParams = self.getQueryParameters();
            if (queryParams && queryParams['page'] === 'design') {
                designButton.click();
            }
        }
        var quantityInput = this._getQuantityInputElement();
        if (quantityInput) {
            var changeFunction = function(event) {
                var value = event.target.value;
                var numberValue = Number(value);
                if (!isNaN(numberValue) && self.ecDriver && self.ecDriver.orders) {
                    self.ecDriver.orders.current.quantity = numberValue;
                }
            };
            quantityInput.onchange = changeFunction;
            quantityInput.oninput = changeFunction;
        }
    },
    _setOrderQuantity: function() {
      if (this.ecDriver.orders && this.ecDriver.orders.current) {
            this.ecDriver.orders.current.quantity = this.getQuantityFromForm();
        	auEditorInitiator.initialKoozieQuantity = this.ecDriver.orders.current.quantity;
        	try {
        	auEditorInitiator.initedBlank = this.ecDriver.products.current.variations.current.options['Product Color'] === "BLANK KOOZEE";
            } catch(ex) { auEditorInitiator.initedBlank = false; }
      }
    }
});
document.addEventListener("DOMContentLoaded", function() {
    auEditorInitiator.init();
    // comment next line to disable preload
    auEditorInitiator.loadEditor();
});
